import * as React from 'react';
import { connect } from 'react-redux';
import { Badge, Image } from 'react-bootstrap';
import NotificationBadge from 'react-notification-badge';
import { BLING_BRAND_NEW_PRODUCT_ID, BLING_LIKE_NEW_PRODUCT_ID, BLING_SCREEN_FIX_PRODUCT_ID, BUILDING_PRODUCT_ID, HOME_CONTENT_PRODUCT_ID, PERSONAL_SAFETY_PRODUCT_ID } from '../../constants/products';
import { toggleHasError, toggleSelfInspectPhotos } from '../../actions/selfInspectActions';
import { setSelectedQuotedCover } from '../../actions/profileActions';
import { QUOTED_COVER_ITEM } from '../../constants/constants';
import './PersonalInsurance.css';

class PersonalInsuranceQuotedCoverCard extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    async handleClick(id) {
        await this.props.dispatchAction(toggleHasError(false));
        await this.props.dispatchAction(toggleSelfInspectPhotos(false));
        await this.props.dispatchAction(setSelectedQuotedCover(id));
        await this.props.onClickHandler(QUOTED_COVER_ITEM);
    }

    render() {
        let cardId = (this.props.profile.selectedPersonalCoverType === QUOTED_COVER_ITEM && this.props.profile.selectedPersonalQuotedCover !== null) ? this.props.profile.selectedPersonalQuotedCover.id : "0";
        let inspectionRequired = (this.props.profile.inspectionItems.filter(x => x.riskItemID === this.props.riskItemId).length > 0);

        //Product overrides
        let productName = (this.props.productNumber === BUILDING_PRODUCT_ID) ? "Buildings" : ((this.props.productNumber === HOME_CONTENT_PRODUCT_ID) ? "Home contents" : ((this.props.productNumber === BLING_BRAND_NEW_PRODUCT_ID || this.props.productNumber === BLING_LIKE_NEW_PRODUCT_ID || this.props.productNumber === BLING_SCREEN_FIX_PRODUCT_ID) && this.props.profile.countryId === 157) ? "Cellphone" : this.props.headerText);
        let description = (this.props.productNumber === PERSONAL_SAFETY_PRODUCT_ID) ? "Personal safety assistance" : this.props.bodyText;

        return (
            <>
                <div className="Personal-insurance-card" id="InsuranceCard">
                    <div className={(this.props.id === cardId ? 'isClicked ' : '') + " tile row noma"} onClick={() => this.handleClick(this.props.id)}>
                        {inspectionRequired &&
                            <div className="col-12 mb-10px nopa card-badge">
                                <Badge className="badge badge-pill"><p>Self-inspection required</p></Badge>
                            </div>
                        }
                        <div className="mr-20px">
                            <div className={this.props.image}></div>
                        </div>
                        <div className="col col-md-9 nopa">
                            <div className={productName === "Portable possessions" ? "row noma" : "row noma"}>
                                <div className="col-12 nopa">
                                    <div className="row noma">
                                        <div className="col nopa">
                                            <p className="mb-6px line-height-normal font-weight-bold">{productName}
                                                {this.props.hasError &&
                                                    <Image className="warning-icon" title="" alt="" src="./images/warning-icon.svg" />
                                                }
                                            </p>
                                            {!this.props.hasError &&
                                                <div className="notifcationBadge text-right">
                                                    <NotificationBadge count={parseInt(this.props.alertCount)} />
                                                </div>
                                            }
                                        </div>
                                        <p className="coverAmounts font-size-16px line-height-normal mb-0px text-right">{this.props.profile.currencySymbol}{this.props.premium}</p>
                                    </div>
                                    <div>
                                        <p className="notification descriptionText nopa mb-2px line-height-normal">{description}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(PersonalInsuranceQuotedCoverCard);